import { RESOURCE_TYPE_LABELS } from "@/lib/resourceTypeLabels";

export const ANY_TYPE = "__any__";

export interface TeamCreator {
  userId: string;
  name: string;
  email: string;
  avatarId: string | null;
}

export interface TeamMember {
  userId: string;
  name: string;
  email: string;
  avatarId: string | null;
}

export interface Team {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  createdBy: TeamCreator | null;
  members: TeamMember[];
  provisionedVia: number;
  isScimManaged: boolean;
}

export interface AccessRule {
  id: string;
  name: string;
  kind: "Static" | "Dynamic";
  resourceType: string | null;
  tagKey: string | null;
  tagValue: string | null;
  resourceCount: number;
  resourceIds: string[];
}

export interface OrgResource {
  id: string;
  name: string;
  type: string;
}

export function resourceTypeLabel(type: string | null): string {
  if (type === null) {
    return "Any type";
  }

  return RESOURCE_TYPE_LABELS[type] ?? type;
}
